import React, { useState } from "react";

import TextField from "@material-ui/core/TextField";

import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import {
  Grid,
  LinearProgress,
  Select,
  OutlinedInput,
  MenuItem,
} from "@material-ui/core";
import { useTheme } from "@material-ui/styles";

// styles
import useStyles from "../../styles";

import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";

export default function ContactInformation(props) {
  var classes = useStyles();
  var theme = useTheme();

  return (
    <form
      className={classes.root + " " + classes.subformsc}
      noValidate
      autoComplete="off"
    >
      <Grid container spacing={2}>
        <Grid
          item
          lg={3}
          md={4}
          sm={6}
          xs={12}
          className={classes.center_elements + " " + classes.griditemc}
        >
          <TextField
          style={window.innerWidth > 500 ? {width: '100%'} : {width: '96%'}}

            InputProps={{
              className: classes.inputc + " " + classes.notchedOutline,
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.matlabelc,
            }}
            className={classes.textfieldvaluec}
            // required
            id="email_id"
            label="EMAIL ID"
            type="text"
            placeholder="johnatan@gmail.com"
            autoComplete="first-name"
          />
        </Grid>
        {/* <Grid
          item
          lg={3}
          md={4}
          sm={6}
          xs={12}
          className={classes.center_elements + " " + classes.griditemc}
        >
          <TextField
          style={window.innerWidth > 500 ? {width: '100%'} : {width: '96%'}}

            InputProps={{
              className: classes.inputc + " " + classes.notchedOutline,
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.matlabelc,
            }}
            className={classes.textfieldvaluec}
            placeholder="9589632669"
            // required
            id="home_phone"
            label="HOME PHONE"
            type="number"
          />
        </Grid> */}

        <Grid
          item
          lg={3}
          md={4}
          sm={6}
          xs={12}
          className={classes.center_elements + " " + classes.griditemc}
        >
          <TextField
          style={window.innerWidth > 500 ? {width: '100%'} : {width: '96%'}}

            InputProps={{
              className: classes.inputc + " " + classes.notchedOutline,
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.matlabelc,
            }}
            className={classes.textfieldvaluec}
            placeholder="9589632669"
            // required
            id="cell"
            label="HOME PHONE"
            type="text"
          />
        </Grid>
        

        {/* <Grid
          item
          lg={3}
          md={4}
          sm={6}
          xs={12}
          className={classes.center_elements + " " + classes.griditemc}
        >
          <TextField
          style={window.innerWidth > 500 ? {width: '100%'} : {width: '96%'}}

            InputProps={{
              className: classes.inputc + " " + classes.notchedOutline,
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.matlabelc,
            }}
            className={classes.textfieldvaluec}
            placeholder="9589632669"
            // required
            id="cell_phone"
            label="CELL PHONE"
            type="number"
          />
        </Grid> */}
              <Grid
          item
          lg={3}
          md={4}
          sm={6}
          xs={12}
          className={classes.center_elements + " " + classes.griditemc}
        >
          <TextField
          style={window.innerWidth > 500 ? {width: '100%'} : {width: '96%'}}

            InputProps={{
              className: classes.inputc + " " + classes.notchedOutline,
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.matlabelc,
            }}
            className={classes.textfieldvaluec}
            placeholder="9589632669"
            // required
            id="cell"
            label="CELL PHONE"
            type="text"
          />
        </Grid>
        <Grid
          item
          lg={3}
          md={4}
          sm={6}
          xs={12}
          className={classes.center_elements + " " + classes.griditemc}
        >
          <TextField
          style={window.innerWidth > 500 ? {width: '100%'} : {width: '96%'}}

            InputProps={{
              className: classes.inputc + " " + classes.notchedOutline,
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.matlabelc,
            }}
            className={classes.textfieldvaluec}
            placeholder="Fax"
            // required
            id="fax"
            label="FAX"
            type="text"
          />
        </Grid>

        <Grid
          item
          lg={6}
          md={4}
          sm={6}
          xs={12}
          className={classes.center_elements + " " + classes.griditemc}
        >
          <TextField
          style={window.innerWidth > 500 ? {width: '100%'} : {width: '96%'}}

            style={{ width: "100%" }}
            InputProps={{
              className: classes.inputc + " " + classes.notchedOutline,
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.matlabelc,
            }}
            className={classes.textfieldvaluec}
            placeholder="105, Jairampur Colony"
            // required
            id="home_address"
            label="HOME ADDRESS"
            type="text"
            autoComplete="first-name"
          />
        </Grid>
        <Grid
          item
          lg={3}
          md={4}
          sm={6}
          xs={12}
          className={classes.center_elements + " " + classes.griditemc}
        >
          <TextField
          style={window.innerWidth > 500 ? {width: '100%'} : {width: '96%'}}

            InputProps={{
              className: classes.inputc + " " + classes.notchedOutline,
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.matlabelc,
            }}
            // required
            id="zip_code"
            className={classes.textfieldvaluec}
            placeholder="452007"
            label="ZIP/POSTAL CODE"
            type="text"
            autoComplete="first-name"
          />
        </Grid>
        <Grid
          item
          lg={3}
          md={4}
          sm={6}
          xs={12}
          className={classes.center_elements + " " + classes.griditemc}
        >
          <TextField
          style={window.innerWidth > 500 ? {width: '100%'} : {width: '96%'}}

            InputProps={{
              className: classes.inputc + " " + classes.notchedOutline,
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.matlabelc,
            }}
            // required
            id="city"
            className={classes.textfieldvaluec}
            placeholder="Indore"
            label="CITY"
            type="text"
            autoComplete="first-name"
          />
        </Grid>
        <Grid
          item
          lg={3}
          md={4}
          sm={6}
          xs={12}
          className={classes.center_elements + " " + classes.griditemc}
        >
          <TextField
          style={window.innerWidth > 500 ? {width: '100%'} : {width: '96%'}}

            InputProps={{
              className: classes.inputc + " " + classes.notchedOutline,
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.matlabelc,
            }}
            // required
            id="state"
            className={classes.textfieldvaluec}
            placeholder="Madhya Pradesh"
            label="STATE"
            type="text"
            autoComplete="first-name"
          />
        </Grid>

        <Grid
          item
          lg={3}
          md={4}
          sm={6}
          xs={12}
          className={classes.center_elements + " " + classes.griditemc}
        >
          <TextField
          style={window.innerWidth > 500 ? {width: '100%'} : {width: '96%'}}

            InputProps={{
              className: classes.inputc + " " + classes.notchedOutline,
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.matlabelc,
            }}
            // required
            id="country"
            label="COUNTRY"
            className={classes.textfieldvaluec}
            placeholder="India"
            type="text"
            autoComplete="first-name"
          />
        </Grid>
      </Grid>
    </form>
  );
}
